'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Input } from '@common/components';
import { FOCUS_RING } from '@common/components/interaction';
import { useClipboard } from '@common/hooks';
import SvgAlignBack from '@common/icon/SvgAlignBack';
import SvgChatbubble from '@common/icon/SvgChatbubble';
import { cn } from '@core/utils';
import Image from 'next/image';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import { useKakaoShare } from '@/hooks/useKakaoShare';
import { getStaticCdnUrl } from '@/utils';
import { guideChannelOf } from '../../_utils/guide/guideContent';
import { CHANNEL_LABEL } from '../../_utils/labels';
import { linkCopyTextOf, shortLinkOf, shortLinkUrlOf, targetTextOf } from '../../_utils/links';
import type { PartnersLink } from '../../_utils/types';
import { GuideSection } from './GuideSection';
const DONE_DESCRIPTION = '링크가 만들어졌어요. 콘텐츠에 넣어 공유해 보세요';
const KAKAO_SHARE = {
  title: '웰로 파트너스',
  description: '내가 공유한 링크로 기부를 시작해요!',
  imageUrl: getStaticCdnUrl('partners/kakao-share-v2.png')
};
interface LinkDoneDialogProps {
  link: PartnersLink | null;
  onClose: () => void;
  isCreated?: boolean;
}
export const LinkDoneDialog = t0 => {
  const $ = _c(15);
  const {
    link,
    onClose,
    isCreated: t1
  } = t0;
  const isCreated = t1 === undefined ? false : t1;
  const copyToClipboard = useClipboard();
  const {
    isInitialized,
    shareToKakao
  } = useKakaoShare();
  const t2 = link !== null;
  const t3 = link?.contentName;
  let t4;
  if ($[0] !== isCreated || $[1] !== link) {
    t4 = link ? <div className="flex flex-col gap-8 pb-8 font-800"><h2 className="break-words typo-inherit">{link.contentName}</h2>{isCreated ? <p className="font-400 text-Gray-500 typo-body4">{DONE_DESCRIPTION}</p> : null}</div> : undefined;
    $[0] = isCreated;
    $[1] = link;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== copyToClipboard || $[4] !== isCreated || $[5] !== isInitialized || $[6] !== link || $[7] !== shareToKakao) {
    t5 = link ? <div className="flex flex-col gap-24 pb-24 xl:gap-32">{isCreated ? <p className="-mt-24 text-Gray-600 typo-body4 xl:hidden">{DONE_DESCRIPTION}</p> : null}<div className="flex flex-col gap-12 rounded-small bg-Gray-25 p-16 xl:gap-16"><dl className="flex flex-col gap-8">{[{
            label: "\uCF58\uD150\uCE20\uBA85",
            value: link.contentName
          }, {
            label: "\uC5F0\uACB0 \uB300\uC0C1",
            value: targetTextOf(link)
          }, {
            label: "\uCC44\uB110",
            value: CHANNEL_LABEL[link.channel]
          }].map(_temp)}</dl><div className="flex flex-col gap-12 xl:gap-8"><Input readOnly={true} dimensions="H40" aria-label={"\uB9C1\uD06C \uC8FC\uC18C"} value={shortLinkOf(link.code)} /><div className="flex gap-8"><button disabled={!isInitialized} className={cn(FOCUS_RING, "flex h-48 flex-1 items-center justify-center gap-8 rounded-small bg-Y-400 font-700 text-Gray-900 transition-opacity typo-body3 enabled:hover:opacity-90 enabled:active:opacity-80 disabled:opacity-50 xl:w-156 xl:flex-none")} onClick={() => shareToKakao(shortLinkUrlOf(link.code), KAKAO_SHARE.title, KAKAO_SHARE.description, KAKAO_SHARE.imageUrl)}><SvgChatbubble aria-hidden={true} className="size-20 xl:hidden" /><Image unoptimized={true} alt="" width={24} height={24} src="/assets/pngs/login/kakao.png" className="hidden xl:block" />카카오톡 공유</button><Button theme="sub-line" dimensions="H48" className="flex-1" onClick={() => copyToClipboard({
              value: linkCopyTextOf(link.code),
              message: "\uB9C1\uD06C\uBCF5\uC0AC \uC644\uB8CC!"
            })}><SvgAlignBack aria-hidden={true} className="size-16 text-Gray-600" />링크복사</Button></div></div></div><div className="flex flex-col gap-12"><h3 className="font-700 text-Gray-900 typo-body2 xl:typo-h6">작성 가이드를 참고해주세요!</h3><GuideSection channel={guideChannelOf(link.channel)} linkUrl={shortLinkUrlOf(link.code)} /></div></div> : null;
    $[3] = copyToClipboard;
    $[4] = isCreated;
    $[5] = isInitialized;
    $[6] = link;
    $[7] = shareToKakao;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onClose || $[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <ResponsiveDialog opened={t2} onClose={onClose} drawerType="bottom" title={t3} modalHeader={t4}>{t5}</ResponsiveDialog>;
    $[9] = onClose;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
function _temp(row) {
  return <div key={row.label} className="flex justify-between gap-12"><dt className="w-72 shrink-0 text-Gray-700 typo-caption1">{row.label}</dt><dd className="min-w-0 break-words text-right text-Gray-900 typo-body4">{row.value}</dd></div>;
}